/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { FC, ReactElement, useContext, useState } from 'react';
import { MatchesContext } from '../../context/context';
import { trans } from '../../helpers/helperFunctions';

const Dropdown: FC = (): ReactElement => {
  const { setSelectedDisplayOption } = useContext(MatchesContext);

  const [selected, setSelected] = useState<number>(0);

  const onSelectClick = (index: number, dropdownValue: string) => {
    setSelected(index);
    setSelectedDisplayOption(dropdownValue);
  };

  return (
    <div className="dropdown">
      {[trans('gamesByDate'), trans('gamesByGroup')].map((dropdownValue, index) => {
        let className = 'dropdown-select';
        if (index === selected) className = `${className} select-active`;
        return (
          <div
            className={className}
            key={dropdownValue + index}
            onClick={(e) => onSelectClick(index, dropdownValue)}>
            {dropdownValue}
          </div>
        );
      })}
    </div>
  );
};

export default Dropdown;
